export const DEBOUNCE_INTERVAL = "400ms"
